export const diseaseIdToName: {
    [key: string]: {
        name: string;
        maxAge?: { value: number; unit?: string };
        minAge?: { value: number; unit?: string };
    };
} = {
    'd-7337452126': {
        name: 'Tuberculosis',
        minAge: {
            value: 0,
            unit: 'years',
        },
        maxAge: {
            value: 5,
            unit: 'years',
        },
    },
    'd-5007465174': {
        name: 'Covid-19',
    },
    'd-2418866185': {
        name: 'Td',
    },
    'd-4655024564': {
        name: 'Hepatitis B',
        minAge: {
            value: 0,
            unit: 'years',
        },
    },
    'd-5097881859': {
        name: 'Polio',
        minAge: {
            value: 0,
            unit: 'years',
        },
        maxAge: {
            value: 6,
            unit: 'years',
        },
    },
    'd-4298976606': {
        name: 'DTwP/DTaP',
    },
    'd-22760008': {
        name: 'Hib',
    },
    'd-9034208029': {
        name: 'Rotavirus',
        minAge: {
            value: 6,
            unit: 'weeks',
        },
        maxAge: {
            value: 9,
            unit: 'months',
        },
    },
    'd-2268625014': {
        name: 'Influenza',
        minAge: {
            value: 6,
            unit: 'weeks',
        },
    },
    'd-693157766': {
        name: 'Typhoid',
    },
    'd-5346737635': {
        name: 'MMR',
        minAge: {
            value: 9,
            unit: 'months',
        },
    },
    'd-4137684137': {
        name: 'Meningococcal',
        minAge: {
            value: 9,
            unit: 'months',
        },
    },
    'd-2162411593': {
        name: 'Cholera',
        minAge: {
            value: 12,
            unit: 'months',
        },
    },
    'd-665332972': {
        name: 'Herpes zoster',
    },
    'd-3847466272': {
        name: 'JE',
        minAge: {
            value: 12,
            unit: 'months',
        },
    },
    'd-7315535452': {
        name: 'Pneumococcal',
    },
    'd-4418575871': {
        name: 'Hepatitis A',
        minAge: {
            value: 12,
            unit: 'months',
        },
    },
    'd-4143566044': {
        name: 'Varicella',
        minAge: {
            value: 15,
            unit: 'months',
        },
    },
    'd-7661031482': {
        name: 'HPV',
        minAge: {
            value: 9,
            unit: 'years',
        },
    },
    'd-5344860806': {
        name: 'Rabies',
        minAge: {
            value: 2,
            unit: 'years',
        },
    },
    // 'Tdap/Td': {
    //     name: 'Tdap/Td',
    //     minAge: {
    //         value: 16,
    //         unit: 'years',
    //     },
    // },
    // PCV: {
    //     name: 'PCV',
    //     minAge: {
    //         value: 6,
    //         unit: 'weeks',
    //     },
    // },
    // PPSV23: {
    //     name: 'PPSV23',
    //     minAge: {
    //         value: 2,
    //         unit: 'years',
    //     },
    // },
    'd-7232329186': {
        name: 'Yellow Fever',
        minAge: {
            value: 9,
            unit: 'months',
        },
    },
    // Twinrix: {
    //     name: 'Twinrix',
    // },
    // 'COVID-19': {
    //     name: 'COVID-19',
    // },
    // Tdap: {
    //     name: 'Tdap',
    //     minAge: {
    //         value: 7,
    //         unit: 'years',
    //     },
    // },
    // Shingrix: {
    //     name: 'Shingrix',
    // },
};

export enum VACCINATION_STATUS {
    DUE = 'Due',
    GIVEN = 'Given',
    MISSED = 'Missed',
    PATIENT_REFUSED = 'Patient Refused',
}

export type I_VACCINATION_STATUS =
    | VACCINATION_STATUS.DUE
    | VACCINATION_STATUS.GIVEN
    | VACCINATION_STATUS.MISSED
    | VACCINATION_STATUS.PATIENT_REFUSED;

export interface Column {
    // I may need this to easily build disease vs age group column on UI. Since dose.dateRange is a very nested data
    ageGroupName?: string;
    minAgeFromBirth: string;
    maxAgeFromBirth?: string;
}

export interface VaccineInfo {
    plan: {
        [diseaseId: string]: {
            vaccineSchedule: DoseInfo;
        };
    };
    columns: {
        plan: Column[];
        otherVaccs: Column[];
    };
    otherVaccs: any;
}

export interface DoseInfo {
    [ageGroup: string]: Dose[];
}

export interface IVaccineStatus {
    id: string;
    status?: I_VACCINATION_STATUS;
    date?: string;
    brand?: BrandInfo;
    batchNumber?: string;
    notes?: string;
    diseaseId: string;
    doseNo: number;
    ageGroup?: string;
    name: string;
}

export interface Dose {
    vaccineId: string;
    status?: IVaccineStatus;
    vaccineName: string;
    brands: BrandInfo[];
    diseaseId: string;
    doseNo: number; // will represent nth dose i.e. Dose 1 or Dose 2...
    dependencies?: {
        // doseInfo of vaccine this current vaccine is dependent on
        vaccineId: string;
        brandId?: string;
        doseNo?: number;
        gap?: number; // number of days/hours necessary gap from the dependency vaccine. In case no gap or no dependency then lets keep this undefined
    }[];
    dateRange: {
        // Time frame between which vaccine should be given. Should we keep these in hours or days?
        minAgeFromBirth: string; // can be undefined too
        maxAgeFromBirth?: string;
        ageGroupName?: string;
    };
    type: string; // type of vaccine. Maybe this will be useful for the My plan CTA given in design, will need more clarity on this
}

export interface BrandInfo {
    brandId: string;
    brandName: string;
    diseases: string[]; /// string of disease ids...will ask if they can provide us this info
    brandSpecificDoseInfo?: any; // does dose numbers change with different brands? If not hen we may not need this key
}

export type VaccineInfoAPIResponse = Partial<VaccineInfo>;
